import { DynamicIcon } from 'foundations-assets/icons/DynamicIcon';
import styled from 'foundations-theming-specialty/utils';
import { useId } from 'react';
import { AGENT_ICON_GRADIENT_STOPS } from '../../../styles/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNamedIconFlex = styled.div.withConfig({
  displayName: "AgentNamedIcon__StyledNamedIconFlex"
})(["display:flex;align-items:center;justify-content:center;border-radius:", ";background-color:", ";block-size:", ";inline-size:", ";margin-block-end:", ";position:relative;svg[data-agent-icon-gradient]{position:absolute;overflow:hidden;block-size:0 !important;inline-size:0 !important;}svg:not([data-agent-icon-gradient]){flex-shrink:0;block-size:", " !important;inline-size:", " !important;fill:", " !important;}svg:not([data-agent-icon-gradient]) [stroke]:not([stroke='none']){stroke:", " !important;}"], ({
  theme,
  background,
  borderRadius
}) => {
  if (background !== 'gradient') {
    return theme.borderRadius['0'];
  }
  return borderRadius != null ? `${borderRadius}px` : theme.borderRadius['300'];
}, props => props.background === 'gradient' ? props.theme.color['fill-accent-orange-subtle-alt'] : 'transparent', props => props.size, props => props.size, ({
  theme,
  marginBlockEnd
}) => {
  const spaceKey = marginBlockEnd || '400';
  return theme.space[spaceKey];
}, props => props.iconSize, props => props.iconSize, ({
  gradientId
}) => `url(#${gradientId})`, ({
  gradientId
}) => `url(#${gradientId})`);
export const AgentNamedIcon = ({
  Icon,
  iconName,
  marginBlockEnd,
  size,
  borderRadius,
  background = 'none',
  testId = 'agent-named-icon'
}) => {
  const gradientId = `agent-icon-gradient-${useId().replace(/:/g, '')}`;
  const containerSize = `${size}px`;
  const iconSize = background === 'gradient' ? `${Math.round(size * 0.6)}px` : containerSize;
  return /*#__PURE__*/_jsxs(StyledNamedIconFlex, {
    borderRadius: borderRadius,
    size: containerSize,
    iconSize: iconSize,
    marginBlockEnd: marginBlockEnd,
    gradientId: gradientId,
    background: background,
    "data-test-id": testId,
    children: [/*#__PURE__*/_jsx("svg", {
      width: "0",
      height: "0",
      "aria-hidden": true,
      focusable: false,
      "data-agent-icon-gradient": true,
      children: /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("linearGradient", {
          id: gradientId,
          gradientUnits: "objectBoundingBox",
          x1: "0.42",
          y1: "0",
          x2: "0.58",
          y2: "1",
          children: AGENT_ICON_GRADIENT_STOPS.map(stop => /*#__PURE__*/_jsx("stop", {
            offset: stop.offset,
            stopColor: stop.color
          }, stop.offset))
        })
      })
    }), iconName ? /*#__PURE__*/_jsx(DynamicIcon, {
      name: iconName
    }) : Icon ? /*#__PURE__*/_jsx(Icon, {}) : null]
  });
};